var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import Event from './Event';

var AbstractConnection = function () {
  function AbstractConnection(url, dispatcher) {
    _classCallCheck(this, AbstractConnection);

    this.dispatcher = dispatcher;
    this.messageQueue = [];
    this.trigger = this.trigger.bind(this);
  }

  _createClass(AbstractConnection, [{
    key: 'close',
    value: function close() {}
  }, {
    key: 'trigger',
    value: function trigger(event) {
      if (this.dispatcher.state !== 'connected') {
        return this.messageQueue.push(event);
      } else {
        return this.sendEvent(event);
      }
    }
  }, {
    key: 'sendEvent',
    value: function sendEvent(event) {
      if (this.connectionId != null) {
        return event.connectionId = this.connectionId;
      }
    }
  }, {
    key: 'onClose',
    value: function onClose(event) {
      var closeEvent = void 0;
      if (this.dispatcher && this.dispatcher.conn === this) {
        closeEvent = new Event('connection_closed', event);
        this.dispatcher.state = 'disconnected';
        return this.dispatcher.dispatch(closeEvent);
      }
    }
  }, {
    key: 'onError',
    value: function onError(event) {
      var errorEvent = void 0;
      if (this.dispatcher && this.dispatcher.conn === this) {
        errorEvent = new Event('connection_error', event);
        this.dispatcher.state = 'disconnected';
        return this.dispatcher.dispatch(errorEvent);
      }
    }
  }, {
    key: 'onMessage',
    value: function onMessage(eventData) {
      if (this.dispatcher && this.dispatcher.conn === this) {
        return this.dispatcher.newMessage(eventData);
      }
    }
  }, {
    key: 'setConnectionId',
    value: function setConnectionId(connectionId) {
      this.connectionId = connectionId;
    }
  }, {
    key: 'flushQueue',
    value: function flushQueue() {
      this.messageQueue.forEach(this.trigger);
      return this.messageQueue = [];
    }
  }]);

  return AbstractConnection;
}();

export default AbstractConnection;